<template>
  <Banner
    v-if="showBanner"
    class="banner"
    @close="handleClose"
  >
    <template v-slot:content>
      <div>
        <Icon
          icon="started"
          :scale="1"
        />
        <HeadingMedium>
          Get Started
        </HeadingMedium>
        <!-- TODO:  set the users eligible number once the API is available-->
        <ParagraphBody>
          {{ $options.getStartedText }}
        </ParagraphBody>
        <div class="bannerFooter">
          <IconButton
            icon="add"
            text="Enroll User Groups"
            type="primary"
            @click="handleEnrollByUserGroup"
          />
        </div>
      </div>
    </template>
  </Banner>
</template>

<script>
import {
  Banner,
  HeadingMedium,
  Icon,
  IconButton,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  LocalStorageConsts,
} from 'client/util/Constants';
import LocalStorageService from 'client/util/LocalStorageService';

export default {
  name: 'PasswordManagerGetStartedBanner',

  components: {
    Banner,
    HeadingMedium,
    Icon,
    IconButton,
    ParagraphBody,
  },

  LocalStorageService,

  data() {
    return {
      showBanner: false,
    };
  },

  getStartedText: 'To get started, enroll users by user group. They will receive an activation email and will be guided through the setup process. You can view and manage their status in the Users tab.',

  created() {
    this.isBannerDismissed();
  },

  methods: {
    dismissSettingsBanner() {
      const { getValue, setItem } = this.$options.LocalStorageService;
      if (!getValue(LocalStorageConsts.bannerDismissedPasswordManager)) {
        setItem(LocalStorageConsts.bannerDismissedPasswordManager, 'seen');
      }
    },

    handleClose() {
      this.showBanner = false;
      this.dismissSettingsBanner();
    },

    handleEnrollByUserGroup() {
      this.$emit('showGroupModal');
    },

    isBannerDismissed() {
      const { getValue } = this.$options.LocalStorageService;
      if (getValue(LocalStorageConsts.bannerDismissedPasswordManager)) {
        this.showBanner = false;
      } else {
        this.showBanner = true;
      }
    },
  },
};
</script>

<style scoped>
  .banner.banner {
    background-color: var(--jcSuccess50);
    border: var(--jc-border);
    max-height: fit-content;
    padding-bottom: var(--jc-spacer);
  }

  .bannerFooter {
    border-top: var(--jc-border);
    padding-top: var(--jc-spacer);
  }
</style>
